// Holds the changes/get sweep's mid-sweep resume point as { cursor, cursorId },
// or null when no sweep is part-way through. Set after each applied page, cleared
// when a sweep completes or on logout. See src/action/sync-checkpoint-actions.js
// for why both halves are needed. Session-only (see store.js blacklist).

import {
  SYNC_CHECKPOINT_SET,
  SYNC_CHECKPOINT_CLEAR,
} from '../action/sync-checkpoint-actions'

const initialState = null

export default (state = initialState, action) => {
  switch (action.type) {
    case SYNC_CHECKPOINT_SET:
      return action.payload
    case SYNC_CHECKPOINT_CLEAR:
    // A 401 mid-sweep must not leave a resume point behind for the next user.
    case 'LOGOUT':
      return initialState
    default:
      return state
  }
}
